import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto } from '../../../models/adapters/ReservationEventAdapter';
import { guestArrived, GuestArrivedActionType, guestArrivedFailed, guestArrivedSaved } from '../../actions/reservation/guestArrived';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* guestArrivedSaga({ payload }: GuestArrivedActionType) {
  const { reservation } = payload;
  const token = yield getAuthenticationToken();
  const reservationEventDto = toDto(reservation.reservationEvent);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updateReservationEvent, token, {
    placeUuid: reservation.placeUuid,
    reservationEvent: reservationEventDto,
  });
  const { error } = response;
  const timestamp = moment();
  if (!error) {
    yield put(guestArrivedSaved({ reservation, reservationUuid: reservation.uuid, timestamp }));
  } else {
    yield put(guestArrivedFailed({ reservationUuid: reservation.uuid, timestamp }));
  }
}

export default function* watchGuestArrivedSaga() {
  yield takeEvery(guestArrived, guestArrivedSaga);
}
